export default "__VITE_PUBLIC_ASSET__9bfc6a4f__"